import { useDispatch, useSelector } from 'react-redux'
import { getCannotReopenTabDialog } from '../Selectors'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { useCallback } from 'react'
import { setCannotReopenTabDialog } from '../ActionCreators'

export const VNCannotReopenTabDialog = () => {
  const dispatch = useDispatch()

  const open = useSelector((state) => getCannotReopenTabDialog(state))

  const closeHandler = useCallback(() => {
    dispatch(setCannotReopenTabDialog({ open: false }))
  }, [dispatch])

  if (!open) {
    return null
  }

  return (
    <ConfirmModalV2
      headerText={'Cannot Reopen Tab'}
      subtext={'Order is in a state that does not allow it to be reopened'}
      singleButtonOnly
      buttonTwoText={'OKAY'}
      onButtonTwoClick={closeHandler}
    />
  )
}
